import { render, staticRenderFns } from "./PortalAbonadoSga.vue?vue&type=template&id=31e34186"
import script from "./PortalAbonadoSga.vue?vue&type=script&lang=js"
export * from "./PortalAbonadoSga.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports